export const CONTACT_FORM_NAME = 'about';



// WEBPACK FOOTER //
// ./src/modules/ContactForm/constants.js